const {formatPhone, formatNSS, formatAge, formatDate, validateForm, formatZip, formatRFC} = require("./validator.js");

(function($){

    function contactUsForm() {

        var form = $("#contact-us-form");
        var title =  $("#contact-us-form button").attr('data-title');
        var sending = $("#contact-us-form button").attr('data-sending');
        var success = $("#contact-us-form button").attr('data-success');

        var fields = $("#contact-us-form input, #contact-us-form select, #contact-us-form textarea");

        var inputTitles = {};

        fields.each(function(i,e){
            if($(e).attr('type')==='text' || $(e).get(0).nodeName ==='TEXTAREA'){
                inputTitles[$(e).attr('name')] = $(e).attr('placeholder');
            }
            if($(e).get(0).nodeName ==='SELECT'){
                inputTitles[$(e).attr('name')] = $(e).find('option').eq(0).html();
            }
        });

        if(validateForm(form,true,null)){
            $.ajax({
                url: contact_us.url,
                type: "POST",
                data: {
                    inputs: form.serialize(),
                    fields: inputTitles
                },
                dataType: "json",
                beforeSend:function(){
                    $("#contact-us-form button").html(sending);
                    $("#contact-us-form button").addClass("disable");
                },
                success: function (res) {
                    // console.log(res);
                    if(res == "success"){
                        // console.log(res);
                        $("#contact-us-form button").html(success);
                        setTimeout(function(){
                            $("#contact-us-form button").html(title);
                            $("#contact-us-form button").removeClass("disable");
                            $("#contact-us-form input").val(null);
                            $("#contact-us-form textarea").val(null);
                            $("#contact-us-form select").prop('selectedIndex',0);
                        },7000);
                    }
                }
            })
        }
        
    }

    function joinUsForm() {

        var form = $("#join-us-form");
        var title =  $("#join-us-form button").attr('data-title');
        var sending = $("#join-us-form button").attr('data-sending');
        var success = $("#join-us-form button").attr('data-success');

        var fields = $("#join-us-form input, #join-us-form textarea, #join-us-form select, #join-us-form input[type='radio']");

        var inputTitles = {};

        fields.each(function(i,e){
            if($(e).attr('type')==='text'){
                inputTitles[$(e).attr('name')] = $(e).attr('placeholder');
            }
            if($(e).get(0).nodeName ==='SELECT'){
                inputTitles[$(e).attr('name')] = $(e).find('option').eq(0).html();
            }
            if($(e).attr('type')==='radio'){
                inputTitles[$(e).attr('name')] = $(e).parent().parent().find('span').html();
            }
        });

        if(validateForm(form,true,'#join-us-form-container')){
            $.ajax({
                url: join_us.url,
                type: "POST",
                data: {
                    inputs: form.serialize(),
                    fields: inputTitles
                },
                dataType: "json",
                beforeSend:function(){
                    $("#join-us-form button").html(sending);
                    $("#join-us-form button").addClass("disable");
                },
                success: function (res) {
                    // console.log(res);
                    if(res == "success"){
                        // console.log(res);
                        $("#join-us-form button").html(success);
                        setTimeout(function(){
                            $("#join-us-form button").html(title);
                            $("#join-us-form button").removeClass("disable");
                            $("#join-us-form .close-form").trigger('click');
                        },7000);
                    }
                }
            })
        }
        
    }

    $(document).ready(function () {

        $("#join-us a, .join-us-top").click(function(e){
            e.preventDefault();
            $("#join-us-form-container").removeClass('hide');
        });
        $("#join-us-form .close-form").click(function(e){
            e.preventDefault();
            $("#join-us-form-container").addClass('hide');
            $("#join-us-form input").val(null);
            $("#join-us-form select").prop('selectedIndex',0);
            $("#join-us-form input[type='radio']").prop('checked', false);
        });

        $("#contact-us-form button").click(function(e){
            e.preventDefault();
            contactUsForm();
        });

        $("#join-us-form button").click(function(e){
            e.preventDefault();
            joinUsForm();
        });

        $("input[name='phone']").keyup(function () {
            formatPhone($(this));
        });

        // $("input[name='social_security_number']").keyup(function () {
        //     formatNSS($(this));
        // });

        $("input[name='age']").keyup(function () {
            formatAge($(this));
        });

        $("input[name='date_of_birth']").keyup(function () {
            formatDate($(this));
        });

        $("input[name='zip']").keyup(function () {
            formatZip($(this));
        });

        // $("input[name='rfc']").keyup(function () {
        //     formatRFC($(this));
        // });

        $("input,textarea,select").focus(function (e) {
            $(this).removeClass("error");
            $(this).next("svg").remove();
        });
        $("input[type='radio']").click(function (e) {
            $(this).parent().parent().removeClass("error");
            $(this).parent().parent().find("svg").remove();
        });

    });

})(jQuery)